const GlobalSection = () => {
  return (
    <section className="relative flex flex-col justify-center p-4 global-section__wrapper animated-gradient--blue min-h-[400px]">
      <div className="flex justify-center">
        <img 
          src="https://static2.givesendgo.com/images/globe.png" 
          className="absolute globe__image w-64 h-64 opacity-20 animate-float" 
          alt="Global Reach"
        />
      </div>
      
      <div className="flex flex-col justify-center text-white global-div__wrapper text-center z-10">
        <h2 className="mx-auto text-2xl md:text-4xl lg:text-5xl mb-6">
          DonatePe operates in over
        </h2>
        
        <span 
          id="countries__span" 
          className="mx-auto bg-white text-gsg-teal text-4xl md:text-5xl lg:text-6xl font-bold px-8 py-4 rounded-lg shadow-lg mb-6"
        >
          70 Countries
        </span>
        
        <h3 className="mx-auto text-xl md:text-2xl lg:text-4xl mb-8">
          Making us a world leader in crowdfunding.
        </h3>
        
        <button className="mx-auto text-white text-sm md:text-base lg:text-lg font-medium hover:opacity-80 transition-opacity duration-200 underline underline-offset-4 decoration-2">
          Explore all countries →
        </button>
      </div>
    </section>
  )
}

export default GlobalSection